import getCurrentISOString from '@gef-ui/date-fns-utils/getCurrentISOString';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { errorPropType } from '../../constants';
import { useSendErrorLocal } from '../../hooks';
import CollapsibleErrorView from '../CollapsibleErrorView';
const LocalCollapsibleError = ({ error, sendErrorCallback, ...other })=>{
    const timestamp = useMemo(()=>getCurrentISOString(), []);
    const resolvedError = error.timestamp ? error : {
        ...error,
        timestamp
    };
    const { sendErrorLocal, isError, isSent, isSending } = useSendErrorLocal(sendErrorCallback);
    return /*#__PURE__*/ React.createElement(CollapsibleErrorView, {
        error: resolvedError,
        onSendError: sendErrorLocal,
        isError: isError,
        isSent: isSent,
        isSending: isSending,
        ...other
    });
};
LocalCollapsibleError.propTypes = {
    error: errorPropType.isRequired,
    /**
	 * Custom callback for sending errors to BE called with HTTP body
	 */ sendErrorCallback: PropTypes.func
};
export default LocalCollapsibleError;
